module.exports = __webpack_public_path__ + "static/testi2-246c21b282927561b241324ce5b9d1a8.jpg";